import React from "react";

const SvgGear = ({ color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    viewBox="0 0 24 24"
    stroke={color}
    strokeWidth="1.5"
    fill="none"
    {...props}
  >
    <path
      d="M13.309 3l.186 1a2.0003 2.0003 0 002.1786 1.6334A1.9996 1.9996 0 0016.6 5.29l.842-.58 1.848 1.852-.58.842A2.0002 2.0002 0 0020 10.505l1 .186v2.618l-1 .191a1.9998 1.9998 0 00-1.285 3.1l.58.842-1.857 1.848-.842-.58A2 2 0 0013.5 20l-.186 1h-2.623l-.186-1a2.0005 2.0005 0 00-1.2008-1.4915A2.0005 2.0005 0 007.4 18.71l-.842.58-1.848-1.852.58-.842a1.9999 1.9999 0 00-1.285-3.1l-1-.186v-2.619l1-.186a1.9992 1.9992 0 001.488-1.2026A2 2 0 005.29 7.4l-.58-.842L6.562 4.71l.842.58a2.0001 2.0001 0 003.1-1.285l.186-1L13.309 3z"
      strokeMiterlimit="10"
    ></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);
export default SvgGear;
